<template>
  <header class="mc-rec-header">
    <b-row class="align-items-start">
      <b-col lg="7" class="mb-3 mb-lg-0">
        <h1 class="mc-rec-header__title">Resultados das recomendações por WhatsApp</h1>
        <p class="mc-rec-header__subtitle">
          Acompanhe o impacto acumulado da funcionalidade e analise a performance por período.
        </p>
      </b-col>
      <b-col lg="5">
        <div class="d-flex flex-column align-items-lg-end gap-2">
          <div v-if="dataAtivacao" class="small text-right mb-1">
            <span class="d-inline-flex align-items-center px-2 py-1 rounded" style="background: rgba(91,2,140,0.08); color: #5b028c; font-weight: 600;">
              <span class="mr-1" style="width:6px;height:6px;border-radius:50%;background:#2d9d78;display:inline-block;" />
              Ativa desde {{ dataAtivacao }}
            </span>
          </div>
          <div class="d-flex flex-wrap align-items-center justify-content-lg-end" style="gap: 0.5rem;">
            <b-form-select v-model="presetLocal" :options="presetOptions" size="sm" class="mc-rec-select" style="min-width: 160px; border-color: rgba(91,2,140,0.2);" @change="onPresetChange" />
            <template v-if="presetLocal === 'personalizado'">
              <b-form-input v-model="customStartLocal" type="date" size="sm" style="width: 140px;" />
              <b-form-input v-model="customEndLocal" type="date" size="sm" style="width: 140px;" />
            </template>
            <b-button size="sm" class="mc-rec-btn-coral" @click="emitAplicar">Aplicar</b-button>
          </div>
          <b-form-checkbox v-model="compareLocal" switch class="small mt-1" @change="$emit('toggle-comparar', compareLocal)">
            Comparar com período anterior
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  </header>
</template>

<script>
import {
  BRow,
  BCol,
  BFormSelect,
  BFormInput,
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue'
import { PRESET_OPTIONS } from './utils/periodPresets'

export default {
  name: 'RecommendationDashboardHeader',
  components: {
    BRow,
    BCol,
    BFormSelect,
    BFormInput,
    BButton,
    BFormCheckbox,
  },
  props: {
    dataAtivacao: { type: String, default: '' },
    preset: { type: String, default: '30d' },
    customStart: { type: String, default: '' },
    customEnd: { type: String, default: '' },
    compararPeriodoAnterior: { type: Boolean, default: false },
  },
  data() {
    return {
      presetLocal: this.preset,
      customStartLocal: this.customStart,
      customEndLocal: this.customEnd,
      compareLocal: this.compararPeriodoAnterior,
      presetOptions: PRESET_OPTIONS,
    }
  },
  watch: {
    preset(v) { this.presetLocal = v },
    customStart(v) { this.customStartLocal = v },
    customEnd(v) { this.customEndLocal = v },
    compararPeriodoAnterior(v) { this.compareLocal = v },
  },
  methods: {
    onPresetChange() {
      this.$emit('update:preset', this.presetLocal)
    },
    emitAplicar() {
      this.$emit('aplicar-periodo', {
        preset: this.presetLocal,
        customStart: this.customStartLocal,
        customEnd: this.customEndLocal,
      })
    },
  },
}
</script>
